export const siteLinks = [
	{
		title: 'About',
		link: [
			{
				title: 'Organogram',
				link: `/about/organogram/#gsc.tab=0`,
				ext: false
			},
			// {
			// 	title: 'Zones & Wards',
			// 	link: `/about/zones-and-rewards/`,
			// 	ext: false
			// }
		],
		ext: true
	},
	{
		title: 'Services',
		link: [
			{
				title: 'Street Lighting',
				link: `/services/street-lighting/`,
				ext: false
			},
			{
				title: 'Marriage Certificate',
				link: `/services/marriage-certificate/`,
				ext: false
			},
			{
				title: 'Holding Tax',
				link: `https://sujog.odisha.gov.in`,
				ext: true
			},
			{
				title: 'Building & Water Plan',
				link: `/services/building-and-water-plan/`,
				ext: false
			},
			{
				title: 'Trade License',
				link: `/services/trade-license/`,
				ext: false
			},
			{
				title: 'Street Vendor',
				link: `/services/street-vendor/`,
				ext: false
			},
			// {
			// 	title: 'Vending Zone',
			// 	link: `/services/vending-zone/`,
			// 	ext: false
			// },
			// {
			// 	title: 'Pension',
			// 	link: `/services/pension/`,
			// 	ext: false
			// },
			// {
			// 	title: 'School Viklang Scholarship',
			// 	link: `/services/school-viklang-scholarship/`,
			// 	ext: false
			// },
			// {
			// 	title: 'SSEPD (Social Security and Empowerment of Disability)',
			// 	link: `/services/ssepd/`,
			// 	ext: false
			// }
		],
		ext: true
	},
	{
		title: 'Information center',
		link: [
			{
				title: 'Birth Certificate',
				link: `/information-center/birth-certificate/`,
				ext: false
			},
			{
				title: 'Death Certificate',
				link: `/information-center/death-certificate/`,
				ext: false
			},
			{
				title: 'Jaga Mission',
				link: `/information-center/jaga-mission/`,
				ext: false
			},
			{
				title: 'Aahar',
				link: `/information-center/aahar/`,
				ext: false
			},
			// {
			// 	title: 'Din Dayal Antardoya Yojana',
			// 	link: `/information-center/din-dayal-antardoya-yojana/`,
			// 	ext: false
			// },
			{
				title: 'Day - NULM',
				link: `/information-center/day-nulm/`,
				ext: false
			},
			// {
			// 	title: 'MUKTA -- Mukhyamantri Karma Tatpara Abhiyan Yojana',
			// 	link: `/information-center/mukta/`,
			// 	ext: false
			// },
			// {
			// 	title: 'Prayas',
			// 	link: `/information-center/prayas/`,
			// 	ext: false
			// }
		],
		ext: true
	},
	{
		title: 'Online booking',
		link: [
			{
				title: 'Kalyan Mandap',
				link: `/online/kalyan-mandap/`,
				ext: false
			},
			{
				title: 'Cesspool Vehicle',
				link: `/online/cesspool-vehicle/`,
				ext: false
			}
		],
		ext: true
	},
	{
		title: 'Downloads',
		link: `/downloads/`,
		ext: false
	},
	{
		title: 'Public Disclosure',
		link: `/public-disclosure/`,
		ext: false
	},
	{
		title: 'Tenders',
		link: `/tenders/`,
		ext: false
	},
	{
		title: 'Grievance',
		link: `/grievance/`,
		ext: false
	},
	// {
	// 	title: 'Parks and recreation',
	// 	link: `/parks-and-recreation/`,
	// 	ext: false
	// },
	// {
	// 	title: 'Photo gallery',
	// 	link: `/gallery/`,
	// 	ext: false
	// },
	// {
	// 	title: 'Contact',
	// 	link: `/contact/`,
	// 	ext: false
	// }
]

export const social = {
	'facebook': `https://www.facebook.com/nacdharamgarhkalahandi`,
	'twitter': `https://twitter.com/nac_dharamgarh`

}

export const slumTableData = [
	{
		name: 'Town Hall Back Side',
		ward_no: 6,
		total_household: 26,
		population: 110,
		in_situ_new_habitat: '',
		is_ward_office: 'YES',
		ward_officer: 'Sunita Gainta',
		designation: 'Community Organizer',
		contact: '8328880232',
		slum_has_parichay: 'NO',
		access_to_comm_center: '',
		any_other_info: ''
	},
	{
		name: 'High School Pada',
		ward_no: 6,
		total_household: 20,
		population: 70,
		in_situ_new_habitat: '',
		is_ward_office: 'YES',
		ward_officer: 'Sunita Gainta',
		designation: 'Community Organizer',
		contact: '8328880232',
		slum_has_parichay: 'NO',
		access_to_comm_center: '',
		any_other_info: ''
	},
	{
		name: 'Gopabandhu Nagar Pada',
		ward_no: 13,
		total_household: 73,
		population: 259,
		in_situ_new_habitat: '',
		is_ward_office: 'YES',
		ward_officer: 'Subasish nayak',
		designation: 'CMM Manager',
		contact: '8270494025',
		slum_has_parichay: 'YES',
		access_to_comm_center: '',
		any_other_info: ''
	}
]

export const slumDwellerTableData = [
	{
		name_of_ulb: 'Dharamgarh',
		name_of_slum: 'Town Hall Back Side',
		ward_no: 6,
		sda_member_name: 'Mahendra Kharsel',
		designation: 'President',
		contact: '7749942192'
	},
	{
		name_of_ulb: 'Dharamgarh',
		name_of_slum: 'Town Hall Back Side',
		ward_no: 6,
		sda_member_name: 'Deepak Sribhastav',
		designation: 'Secretary',
		contact: '9937187728'
	},
	{
		name_of_ulb: 'Dharamgarh',
		name_of_slum: 'High School Pada',
		ward_no: 6,
		sda_member_name: 'Mithila Sunani',
		designation: 'President',
		contact: '8339852013'
	},
	{
		name_of_ulb: 'Dharamgarh',
		name_of_slum: 'High School Pada',
		ward_no: 6,
		sda_member_name: 'Sabar Sunani',
		designation: 'Secretary',
		contact: '8339852013'
	},
	{
		name_of_ulb: 'Dharamgarh',
		name_of_slum: 'Gopabandhu Nagar Pada',
		ward_no: 13,
		sda_member_name: 'Ranjan Samal',
		designation: 'President',
		contact: '8144670519'
	},
	{
		name_of_ulb: 'Dharamgarh',
		name_of_slum: 'Gopabandhu Nagar Pada',
		ward_no: 13,
		sda_member_name: 'Tapan Chandi',
		designation: 'Secretary',
		contact: '9337135479'
	}
]